import { KeyboardEvent } from 'react';

// eslint-disable-next-line import/no-unresolved
import { MessageBodyProps } from '@sendbird/uikit-react/types/ui/MessageContent/MessageBody';

import { getMessageNavigationUrl } from '@pharmaplan/common/helpers/utils';

const enterKey = 'Enter';

const useMessageNavigation = (message: MessageBodyProps['message']) => {
  const navigationUrl = getMessageNavigationUrl(message?.data);
  const isNavigable = !!navigationUrl;

  const handleOpenNavigation = () => {
    if (navigationUrl) {
      globalThis.open(navigationUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleNavigationKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === enterKey) {
      handleOpenNavigation();
    }
  };

  return { isNavigable, handleOpenNavigation, handleNavigationKeyDown };
};

export default useMessageNavigation;
